import api from '../../services/api';

export const defaultPayload = {
  sort_attr: 'STATUS',
  sort_order: 'ASC',
};

export const constructPayload = (filters) => {
  const filterList = [];

  if (filters?.status) {
    const tempObj = {
      query: 'STATUS',
      lookup_type: 'EQUALS',
      value: [filters.status],
    };

    filterList.push(tempObj);
  }
  if (filters?.branch?.length) {
    const tempObj = {
      query: 'STORE_ID',
      lookup_type: 'IN',
      value: filters.branch,
    };

    filterList.push(tempObj);
  }
  if (filters?.startDate && !filters?.endDate) {
    const tempObj = {
      query: 'START_DATE',
      lookup_type: 'EQUALS',
      value: [filters?.startDate],
    };

    filterList.push(tempObj);
  }
  if (filters?.endDate && !filters?.startDate) {
    const tempObj = {
      query: 'END_DATE',
      lookup_type: 'EQUALS',
      value: [filters?.endDate],
    };

    filterList.push(tempObj);
  }
  if (filters?.startDate && filters?.endDate) {
    const tempObj1 = {
      query: 'START_DATE',
      lookup_type: 'GREATER_THAN_EQUAL',
      value: [filters?.startDate],
    };
    const tempObj2 = {
      query: 'END_DATE',
      lookup_type: 'LESS_THAN_EQUAL',
      value: [filters?.endDate],
    };

    filterList.push(tempObj1);
    filterList.push(tempObj2);
  }

  if (filters?.promotion_type) {
    const tempObj = {
      query: 'PROMOTION_TYPE',
      lookup_type: 'EQUALS',
      value: [filters.promotion_type],
    };

    filterList.push(tempObj);
  }
  return filterList;
};

const updatedPayload = (attr, order, querySet) => {
  const updatedPayload = structuredClone(defaultPayload);

  updatedPayload.sort_attr = attr;
  updatedPayload.sort_order = order;
  updatedPayload.query_set = querySet;
  return updatedPayload;
};

/**
 *
 * @param id
 */
export async function deletePromotion(id) {
  try {
    const response = await api.delete(`/api/v1/promotion?promotion_id=${id}`);

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *
 * @param payload
 * @param withoutFilters
 */
export async function getPromotionsList(payload, withoutFilters = true) {
  try {
    let response;

    if (withoutFilters) {
      response = await api.post(`/api/v1/promotion/list?page_size=10&page=${1}`);
    } else {
      response = await api.post('/api/v1/promotion/list?filters-applied', payload);
    }
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

/**
 *
 * @param attr
 * @param order
 * @param querySet
 */
export async function getSortedData(attr, order, querySet) {
  try {
    const response = await api.post(
      '/api/v1/promotion/list',
      updatedPayload(attr, order, querySet)
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *
 * @param page
 * @param attr
 * @param order
 * @param querySet
 */
export async function getPaginatedData(page, attr, order, querySet) {
  // Provide default values if not supplied
  const sortAttr = attr !== undefined ? attr : 'START_DATE';
  const sortOrder = order !== undefined ? order : 'DESC';

  try {
    let response;

    if (querySet?.length) {
      response = await api.post(
        `/api/v1/promotion/list?page_size=10&page=${page}`,
        updatedPayload(sortAttr, sortOrder, querySet)
      );
    } else {
      response = await api.post(`/api/v1/promotion/list?page_size=10&page=${page}`);
    }
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *
 * @param id
 */
export async function getPromotionData(id) {
  try {
    const response = await api.get(`/api/v1/promotion?promotion_id=${id}`);

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *
 * @param id
 */
export async function duplicatePromotion(id) {
  try {
    const payload = {
      promotion_id: id,
    };
    const response = await api.post('/api/v1/promotion/duplicate', payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
}
